import { useFocused } from '../useFocused';
const FocusProvider = props => {
  return props.children(useFocused(props));
};
FocusProvider.displayName = 'FocusProvider';
export default FocusProvider;